import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { forwardRef, Injectable, Optional, Inject, InjectionToken, NgModule } from '@angular/core';

class DzFontFace {
    constructor(fontFamily, fontFilename, fontOptions) {
        this.fontFamily = fontFamily;
        this.fontFilename = fontFilename;
        this.fontOptions = fontOptions;
    }
}

const DAISY_FONTS = [
    new DzFontFace('FortBook', 'BLKFort-Book', {
        style: 'normal',
        weight: '400',
        display: 'swap'
    }),
    new DzFontFace('FortBookItalic', 'BLKFort-BookItalic', {
        style: 'italic',
        weight: '400',
        display: 'swap'
    }),
    new DzFontFace('FortBold', 'BLKFort-Bold', {
        style: 'normal',
        weight: '800',
        display: 'swap'
    }),
    new DzFontFace('FortBoldItalic', 'BLKFort-BoldItalic', {
        style: 'italic',
        weight: '800',
        display: 'swap'
    }),
    new DzFontFace('FortExtraBold', 'BLKFort-Extrabold', {
        style: 'normal',
        weight: '800',
        display: 'swap'
    }),
    new DzFontFace('FortExtraBoldItalic', 'BLKFort-ExtraboldItalic', {
        style: 'italic',
        weight: '800',
        display: 'swap'
    }),
    new DzFontFace('FortCondensedLight', 'BLKFortCond-Light', {
        style: 'normal',
        weight: '300',
        display: 'swap'
    }),
    new DzFontFace('FortCondensedBold', 'BLKFortCond-Bold', {
        style: 'normal',
        weight: '700',
        display: 'swap'
    })
];
class DzFontFaceService {
    constructor(fontPath) {
        this.fontPath = fontPath;
        this.fontSet = [];
        DAISY_FONTS.forEach((font) => {
            this.addFont(font);
        });
    }
    addFont(font) {
        const fontFace = new FontFace(font.fontFamily, `url('${this.fontPath}/${font.fontFilename}.woff2') format('woff2'),
			url('${this.fontPath}/${font.fontFilename}.woff') format('woff'),
			url('${this.fontPath}/${font.fontFilename}.ttf') format('truetype')`, font.fontOptions);
        this.fontSet.push(fontFace);
    }
    async loadFonts(documentToAddFonts) {
        if (!documentToAddFonts) {
            documentToAddFonts = document;
        }
        for (const font of this.fontSet) {
            await font.load().then((loadedFont) => {
                documentToAddFonts.fonts.add(loadedFont);
            });
        }
    }
}
DzFontFaceService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzFontFaceService, deps: [{ token: forwardRef(() => DAISY_FONT_PATH), optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
DzFontFaceService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzFontFaceService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzFontFaceService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [forwardRef(() => DAISY_FONT_PATH)]
                }] }]; } });

const DAISY_FONT_PATH = new InjectionToken('DAISY_FONT_PATH');
class DzFontFaceModule {
    constructor(fontFaceService) {
        this.fontFaceService = fontFaceService;
        this.fontFaceService
            .loadFonts()
            .catch((err) => console.error('Error when loading Daisy FontFaces via DzFontFaceModule. Please check that the requested font paths are correct.\n', err));
    }
    static addFonts(path = '/assets/fonts') {
        return {
            ngModule: DzFontFaceModule,
            providers: [{ provide: DAISY_FONT_PATH, useValue: path }]
        };
    }
}
DzFontFaceModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzFontFaceModule, deps: [{ token: DzFontFaceService }], target: i0.ɵɵFactoryTarget.NgModule });
DzFontFaceModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzFontFaceModule, imports: [CommonModule] });
DzFontFaceModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzFontFaceModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzFontFaceModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [CommonModule]
                }]
        }], ctorParameters: function () { return [{ type: DzFontFaceService }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { DAISY_FONT_PATH, DzFontFace, DzFontFaceModule, DzFontFaceService };
